import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";


@Injectable({
    providedIn: 'root'
})

export class TGEEProspectsChemicalsOtherService
 {
    constructor(protected http: HttpClient) {
    }

    baseurl = environment.apiBaseUrl;

    getTGEEProspectsChemicalsReport() {
        return this.http.get<any[]>(this.baseurl + 'TGEEReport/gettgeeprospectschemicals');
    }
}